export class MailWrapper {
  mail: string;
}
